import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { toast } from 'react-toastify'
import PrivateRoute from '../PersonaliseLessons/config/private-route'
import Loader from '../PersonaliseLessons/components/Loader'
import CourseListPage from './index'
import { fetchToken, setUserEmail } from '../../redux/personaliseLessons/authenticationSlice'
import { fetchCourseList, updateCourseName } from '../../redux/personaliseLessons/courseListSlice'
import { Mixpanel } from '../../config/Mixpanel'

const CourseListAuthenticate = () => {
  const emailID = useSelector((store) => store?.profileDetails?.email)
  const { course_slug } = useParams()
  const [loading, setLoading] = useState(true)
  const dispatch = useDispatch()
  const navigate = useNavigate()

  useEffect(() => {
    if (!emailID) {
      setLoading(false)
      return
    }

    const fetchData = async () => {
      dispatch(setUserEmail(emailID))
      try {
        const response = await dispatch(fetchToken({ email_id: emailID })).unwrap()
        if (!response?.Error) {
          Mixpanel.identify(emailID)
          const courseResponse = await dispatch(fetchCourseList({ uid: response?.uid })).unwrap()
          const firstSubject = courseResponse?.subject_names?.[0]
          if (!firstSubject) {
            toast.error('No courses found! Please try again later.')
            navigate('/login', { replace: true })
            return
          }
          dispatch(updateCourseName(course_slug))
        }
      } catch (err) {
        console.log(err.message)
      } finally {
        setLoading(false)
      }
    }

    fetchData()
  }, [dispatch, emailID, navigate, course_slug])

  if (loading && emailID) {
    return <Loader />
  }

  return (
    <PrivateRoute>
      <CourseListPage />
    </PrivateRoute>
  )
}

export default CourseListAuthenticate
